import type { DonationCTABlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface DonationCTABlockEditorProps {
  content: DonationCTABlockContent | null
  onChange: (content: DonationCTABlockContent) => void
}

export function DonationCTABlockEditor({ content, onChange }: DonationCTABlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<DonationCTABlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Donation CTA</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Heading</Label>
          <Input
            value={c.heading ?? "Support our mission"}
            onChange={(e) => update({ heading: e.target.value })}
            placeholder="Support our mission"
          />
        </div>
        <div>
          <Label>Subtext</Label>
          <Input
            value={c.body ?? ""}
            onChange={(e) => update({ body: e.target.value })}
            placeholder="Your donation makes a difference."
          />
        </div>
        <div>
          <Label>Button text</Label>
          <Input
            value={c.cta_text ?? "Donate now"}
            onChange={(e) => update({ cta_text: e.target.value })}
            placeholder="Donate now"
          />
        </div>
      </CardContent>
    </Card>
  )
}
